import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const CompaniesSlice = createSlice({
  name: "Companies",
  initialState,
  reducers: {
    recieveCompanies(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(c => [c.id, c]));
    },
  },
});

export const {
  recieveCompanies
} = CompaniesSlice.actions

export default CompaniesSlice.reducer;
